import client from '@/lib/axios-client'
import type {
	CreateVirtualPersonBody,
	JobRoleListOutput,
	PeopleOutput,
	PersonListItem,
} from '@/types'

const PEOPLE_URL = '/person'

export async function getPeople(crId?: string): Promise<PeopleOutput> {
	const response = await client.get(PEOPLE_URL, {
		params: crId ? { crId } : undefined,
	})
	return response.data.data
}

export async function getJobRoles(q?: string): Promise<JobRoleListOutput> {
	const response = await client.get(`${PEOPLE_URL}/job-roles`, {
		params: q ? { q } : undefined,
	})
	return response.data.data
}

export async function createVirtualPerson(
	body: CreateVirtualPersonBody,
): Promise<PersonListItem> {
	const response = await client.post(`${PEOPLE_URL}/virtual`, body)
	return response.data.data
}
